export const educationalVideos = [
  {
    id: "VjOcwWMzD_o", // Sirf ID ( /live/ ke baad wala hissa )
    title: "Class 10 Physics: Prakash Ka Paravartan (Reflection of Light) - Full Chapter",
    desc: "Sanjay Sir (Disha Online Classes) dwara padhaya gaya Prakash ka Paravartan. Avtal aur Uttal Darpan ko samjhein. Board Exam 2026 ke liye sabse best video."
  },
  {
    id: "HsjH8keZA1I", // Sirf ID ( youtu.be/ ke baad wala hissa )
    title: "Class 10 Chemistry: Rasayanik Abhikriya (Chemical Reactions) - One Shot",
    desc: "Prince Sir (Target Board) ne is video mein Rasayanik Samikaran ko santulit karna sikhaya hai. 5 Marks ka sawal yahan se pakka aayega."
  },
  {
    id: "h4aP3Zg5jgU", 
    title: "Class 10 Maths: Trigonometry (Trikonmiti) Full Chapter",
    desc: "Trikonmiti ka darr khatam! Sanjay Sir ne bataya Sin, Cos, Tan ka formula yaad karne ki short trick. Bihar Board ke students ke liye special class."
  },
  {
    id: "OSy70X0Cn20", 
    title: "Class 10 Biology: Jaiv Prakram (Life Processes) - Full Explanation",
    desc: "Manushya ka Pachan Tantra (Digestive System) aur Heart beat ko animation ke saath samjhiye. Physics Wallah (PW) ka best lecture."
  },
  {
    id: "wZtE5ET_BYc", 
    title: "Class 10 History: Europe Mein Rashtravad (Nationalism in Europe)",
    desc: "Napoleon kaun tha? Italy aur Germany ka ekikaran kaise hua? Board exam ke liye important dates aur events ki poori jankari Sanjay Sir se."
  },
  {
    id: "aoJp2D_5E_0", 
    title: "Class 10 Hindi: Godhuli Bhag 2 - Shram Vibhajan",
    desc: "Bhimrao Ambedkar dwara likhit paath 'Shram Vibhajan aur Jati Pratha' ka saransh (Summary). Objective questions ke liye zaroor dekhein."
  },
];
